<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t('recherche.mesExports.list.title') }}
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="10">
            <v-text-field
              v-model="searchMesExports"
              :label="$t('recherche.mesExports.list.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              icon
              :title="$t('recherche.mesExports.list.search')"
              color="primary"
              @click="add()"
            >
              <v-icon>mdi-playlist-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-data-table
              :sortBy="['titre']"
              :headers="headersMesExports"
              :search="searchMesExports"
              :items="mesExports"
              item-key="id"
              disable-pagination
              disable-sort
              hide-default-footer
              dense
              single-select
              @item-selected="select"
              @click:row="select"
              ref="mesExports"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-dialog v-model="confirmRemove" persistent max-width="50%">
        <v-card>
          <v-card-title class="accent white--text">
            <v-icon color="white">mdi-alert</v-icon> Suppression de modèle
            d'export
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              Vous vous apprêtez à supprimer ce modèle d'export.
            </p>
            <p>
              Êtes-vous sûr de vouloir continuer ?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="doRemove()">
              {{ $t('button.yes') }}
            </v-btn>
            <v-btn text @click="abortRemove()">
              {{ $t('button.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import toasted from '@/utils/toasted';

export default {
  props: {
    typeObjet: {
      type: String,
    },
  },
  beforeCreate() {},
  created() {
    this.initListe();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  data() {
    return {
      searchMesExports: '',
      mesExports: [],
      headersMesExports: [
        {
          text: this.$t('recherche.mesExports.list.headers.titre'),
          sortable: true,
          value: 'titre',
        },
      ],
      // Pour la confirmation de suppression
      confirmRemove: false,
      idMesExports: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    show() {
      this.initListe();
    },
    /**
     * Charge la liste de MesExports
     */
    initListe() {
      this.$api('export/mes/' + this.typeObjet)
        .get()
        .then(response => {
          this.mesExports = response.body;
        });
    },
    add() {
      const mesExports = {
        id: null,
        titre: null,
        export: {
          scope: null,
          format: null,
          taille: null,
          criteres: [],
        },
      };
      this.$emit('select', mesExports);
    },
    select(mesExports) {
      this.$emit('select', mesExports);
    },
    save(mesExports) {
      if (mesExports) {
        if (mesExports.id) {
          this.update(mesExports);
        } else {
          this.create(mesExports);
        }
      }
    },
    create(mesExports) {
      this.$api('export/mes')
        .put(mesExports)
        .then(
          response => {
            toasted.info('recherche.mesExports.results.create.success');
            this.select(response.body);
            this.initListe();
          },
          () => {
            toasted.error('recherche.mesExports.results.create.error');
          },
        );
    },
    update(mesExports) {
      this.$api('export/mes/' + mesExports.id)
        .post(mesExports)
        .then(
          () => {
            toasted.info('recherche.mesExports.results.update.success');
            this.initListe();
          },
          () => {
            toasted.error('recherche.mesExports.results.update.error');
          },
        );
    },
    remove(idMesExports) {
      if (idMesExports) {
        this.idMesExports = idMesExports;
        this.confirmRemove = true;
      }
    },
    doRemove() {
      if (this.idMesExports) {
        this.$api('export/mes/' + this.idMesExports)
          .delete()
          .then(
            () => {
              toasted.info('recherche.mesExports.results.delete.success');
              this.initListe();
              this.add();
              this.idMesExports = null;
              this.confirmRemove = false;
            },
            () => {
              toasted.error('recherche.mesExports.results.delete.error');
            },
          );
      }
    },
    abortRemove() {
      this.idMesExports = null;
      this.confirmRemove = false;
    },
  },
};
</script>
